import React from 'react'
import {Spinner} from 'react-activity'
import "react-activity/dist/library.css";

export default function Loading(){
    return(
        <div style={{ width: '100%', backgroundColor: 'white',display: 'block', alignItems: 'center', justifyContent: 'center' }}>
            <Spinner size={26} color='black' style={{ display: 'block', marginLeft:'auto', marginRight: 'auto', marginTop: 50 }} /> 
            <h1 style={{ marginTop: 20, textAlign: 'center', fontSize: 18, fontFamily: 'PoppinsRegular' }}>Loading....</h1>
        </div>
    )
}